/* eslint-disable */
export default {
  flipHeader: '다음으로 통화 전환...',
  flip: '전환',
  complete: '전환 완료',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
